import * as z from "zod";

export const idSchema = z
  .union([z.string(), z.object({ toString: z.function() }).passthrough()])
  .transform((val) => String(typeof val === "string" ? val : val.toString()));

export const surrealRecordSchema = z.object({
  id: idSchema,
});
